import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import Edit from './edit'
import { reset, fetch, newDraft } from '../../actions'


const mapStateToProps = ({ fbtSubmissions, settings }, ownProps) => ({
  id: ownProps.routeId,
  data: fbtSubmissions?.data[ownProps.routeId],
  flags: {
    ...fbtSubmissions.flags,
    unsavedChanges: JSON.stringify(fbtSubmissions?.originalDrafts) !== JSON.stringify(fbtSubmissions?.drafts),
  },
  filtered: fbtSubmissions?.filtered,
  userRoles :settings.roles
})

const mapDispatchToProps = (dispatch) => ({
  onReset: () => {
    dispatch(reset())
  },
  onFetch: (id, fleetIds) => {
    const FleetId = fleetIds.join(',')
    dispatch(fetch(null, {
      resourceId: id,
      queryParams: { FleetId }
    }))
  },
  onNewDraft: () => {
    dispatch(newDraft())
  },
})

const ConnectedEdit = connect(mapStateToProps, mapDispatchToProps)(Edit)

const EditWithParams = (props) => {
  const { id } = useParams()
  return <ConnectedEdit {...props} routeId={id} />
}

export default EditWithParams
